module.exports = __webpack_public_path__ + "static/img/gw.c1e88a91.svg";